import React from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import { Stack, IStackStyles } from "office-ui-fabric-react";
import {
  validationSchemaUpdateUser,
  validationSchemaUserShort,
} from "../../../actions/validationSchemas";
import FormBtns from "../../../../common/layout/form/NewFormBtns";
import NewEdditionField from "../../../../common/layout/form/NewEdditionField";
import PhonePrefixField from "../../../../common/layout/form/PhonePrefixField";
import { margin, btnContainer } from "../../../styles/panelForm.styles";
import ActivityIndicator from "../../../../common/layout/ActivityIndicator";
import { useUserForm } from "../../../hooks/useUserForm";
import { useCancelForm } from "../../../hooks/useCancelForm";
import ErrorMessage from "../../../../common/layout/form/ErrorMessage";
import FormHeader from "../FormHeader";
import { textFieldsContainer } from "../../../styles/pickUpPointsForm.styles";
import DisplayText from "../displayData/DisplayText";

const containerS: IStackStyles = {
  root: {
    padding: "40px 10px 20px 10px",
    height: "100%",
  },
};

const UsersForm: React.FC = () => {
  const { t } = useTranslation("admin");
  const {
    add,
    isLoading,
    initValues,
    edit,
    selectedIds,
  } = useUserForm();
  const cancel = useCancelForm();

  const schema = () => {
    if (selectedIds[0]) {
      return validationSchemaUpdateUser;
    } else {
      return validationSchemaUserShort;
    }
  };

  return (
    <Formik
      initialValues={initValues}
      onSubmit={selectedIds[0] ? edit : add}
      enableReinitialize={true}
      validationSchema={schema()}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ handleSubmit }) => (
        <Form translate="yes" onSubmit={handleSubmit}>
          <Stack styles={containerS} verticalAlign="space-between" verticalFill>
            <FormHeader text={selectedIds[0] ? t("nav.editUser") as string : t("nav.inviteUser") as string} />
            {/* {activeClient.basicInformations.multiDepartment && (
              <FormDropDown
                options={departments}
                name="department"
                headerText={t("nav.panelSelectDepartment") as string}
              />
            )} */}
            <div className={textFieldsContainer}>
              {!selectedIds[0] ?
                <NewEdditionField name="email" label={t("nav.email") as string} type="email" /> :
                <DisplayText name={t("nav.email") as string} value={initValues.email} />
              }
              <NewEdditionField name="firstName" label={t("nav.colFirstName") as string} />
              <NewEdditionField name="lastName" label={t("nav.colLastName") as string} />
            {selectedIds[0] && <PhonePrefixField prefixName="phonePrefix" numberName="phoneNumber" label={t("nav.colPhone") as string} required /> }
            </div>
            <Stack.Item>
              {/* <div className={container}>
                <NewFormCheckbox name="isClientAdmin" label={t("nav.companyAdminLabel") as string} />
              </div> */}
              <div className={btnContainer}>
                <FormBtns
                  cancelForm={cancel}
                  submitBtnText={initValues.email ? t("nav.save") as string : t("nav.invite") as string}
                  disabled={isLoading}
                  positionAbsolute={true}
                />
              </div>
            </Stack.Item>
            <div className={margin}>
              {isLoading ? <ActivityIndicator /> : <ErrorMessage />}
            </div>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};

export default UsersForm;